import { render, staticRenderFns } from "./DashboardItemLoan.vue?vue&type=template&id=e498bb00&scoped=true&"
import script from "./DashboardItemLoan.vue?vue&type=script&lang=js&"
export * from "./DashboardItemLoan.vue?vue&type=script&lang=js&"
import style0 from "./DashboardItemLoan.vue?vue&type=style&index=0&id=e498bb00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e498bb00",
  null
  
)

export default component.exports